import useGustoCustomerType from 'containers/payroll/gusto/hooks/useGustoCustomerType/useGustoCustomerType';
import useGustoIsEnabled from '../useGustoIsEnabled/useGustoIsEnabled';

export default function useGustoPaidEnabled() {
  const gustoIsEnabled = useGustoIsEnabled();
  const gustoPaidState = useGustoCustomerType();
  const gustoIsPaid = gustoPaidState !== 'unpaid';
  return gustoIsEnabled && gustoIsPaid;
}
